import { CircularProgress } from '@mui/material';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import Error403 from '../../../pages/Error403';
import Error500 from '../../../pages/Error500';
import AdminAuthContainer from '../AdminAuthContainer';
import ApiKeysContainer from '../ApiKeysContainer';
import KeysList from '../components/AdminApiKeys/KeysList';

const StyledPanelContainer = styled.div``;

const ApiKeys = () => {
    const { apiKeyFetchStatus, apiKeyFetchError } = useContainer(ApiKeysContainer);
    const { isAdmin, isLoading } = useContainer(AdminAuthContainer);

    const renderApiKeys = () => {
        switch (apiKeyFetchStatus) {
            case 'INITIAL':
            case 'LOADING':
                return <CircularProgress />;
            case 'SUCCESS':
                return <KeysList />;
            case 'ERROR':
            default:
                return (
                    <Error500
                        errorMessage={apiKeyFetchError?.response?.statusText}
                        errorData={apiKeyFetchError?.response?.data?.error}
                    />
                );
        }
    };

    if (!isAdmin && !isLoading) {
        return <Error403 />;
    }

    return <StyledPanelContainer>{renderApiKeys()}</StyledPanelContainer>;
};

export default ApiKeys;
